import Swal from 'sweetalert2';
import { APP_VERSION, APP_VERSION_STORAGE_KEY } from '../config/appVersion';

let isCheckingAppVersion = false;

const saveAppVersion = () => {
    try {
        localStorage.setItem(APP_VERSION_STORAGE_KEY, APP_VERSION);
    } catch (e) {
        console.error('Failed to save app version', e);
    }
};

const getStoredAppVersion = () => {
    try {
        return localStorage.getItem(APP_VERSION_STORAGE_KEY);
    } catch (e) {
        console.error('Failed to read app version', e);
        return null;
    }
};

export const checkAppVersion = async () => {
    if (isCheckingAppVersion) return;
    isCheckingAppVersion = true;

    try {
        const storedVersion = getStoredAppVersion();

        // First visit: save silently, no alert
        if (!storedVersion) {
            saveAppVersion();
            return;
        }

        if (storedVersion === APP_VERSION) {
            return;
        }

        await Swal.fire({
            icon: 'info',
            title: 'Version updated',
            text: `App updated to ${APP_VERSION}`,
            showConfirmButton: true,
            confirmButtonColor: '#1a5c9a',
        });

        saveAppVersion();
        window.location.reload();
    } finally {
        isCheckingAppVersion = false;
    }
};

export default checkAppVersion;
